module.exports = __webpack_public_path__ + "static/media/28.dd829f87.jpg";